import React from 'react';
import { motion } from 'framer-motion';
interface FilterOption {
  value: string;
  label: string;
}
interface FilterBarProps {
  options: FilterOption[];
  activeFilter: string;
  onFilterChange: (value: string) => void;
}
export function FilterBar({
  options,
  activeFilter,
  onFilterChange
}: FilterBarProps) {
  return <div className="mb-12 sm:mb-16 overflow-x-auto pb-2 -mx-4 px-4 sm:mx-0 sm:px-0" data-id="element-206">
      <div className="flex gap-3 sm:justify-center min-w-max sm:min-w-0" data-id="element-207">
        {options.map(option => <motion.button key={option.value} onClick={() => onFilterChange(option.value)} className={`relative px-5 sm:px-6 py-2.5 sm:py-3 font-medium text-sm sm:text-[15px] transition-all whitespace-nowrap ${activeFilter === option.value ? 'text-white bg-charcoal' : 'text-charcoal bg-white border border-border hover:border-stone/30'}`} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} data-id="element-208">
            {option.label}
          </motion.button>)}
      </div>
    </div>;
}